var map = {
	"./achievement.svg": 85,
	"./address_image.svg": 86,
	"./animated_ashutosh.png": 87,
	"./animated_logo.svg": 88,
	"./blogs_image.svg": 89,
	"./casepoint_logo.png": 90,
	"./cloud_infrastructure.svg": 91,
	"./codeInLogo.png": 92,
	"./contactMail.png": 93,
	"./coursera_logo.png": 94,
	"./data_science.svg": 95,
	"./deeplearning_ai_logo.png": 96,
	"./delhivery_logo.png": 97,
	"./developerActivity.svg": 98,
	"./dsc_logo.png": 99,
	"./education.svg": 100,
	"./experience.svg": 101,
	"./feelingProud.svg": 102,
	"./freecopy_logo.png": 103,
	"./fullstack.svg": 104,
	"./gcp_logo.png": 105,
	"./github_logo.png": 106,
	"./googleAssistant.jpg": 107,
	"./googleAssistant.svg": 108,
	"./google_logo.png": 109,
	"./ibm_logo.png": 110,
	"./iiitk_logo.png": 111,
	"./intel_logo.jpg": 112,
	"./iu_logo.png": 113,
	"./jsFramework.svg": 114,
	"./legato_logo.png": 115,
	"./linkedin.png": 116,
	"./manOnTable.svg": 117,
	"./microsoft_logo.png": 118,
	"./microvista_logo.png": 119,
	"./microvista_logo.svg": 120,
	"./mozilla_logo.png": 121,
	"./muffito_logo.png": 122,
	"./nextuLogo.jpg": 123,
	"./nptel_logo.png": 124,
	"./portfolio.gif": 125,
	"./programmer.svg": 126,
	"./projects_image.svg": 127,
	"./pwa.png": 128,
	"./saayaHealthLogo.png": 129,
	"./spu_logo.jfif": 130,
	"./stanford_logo.png": 131,
	"./talksCardBack.svg": 132,
	"./talksCardBackAlt.svg": 133,
	"./tiktok_logo.png": 134,
	"./ui_ux_design.svg": 135,
	"./vnsgu_logo.png": 136
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 22;